"use client";

import { cn } from "@/utils/cn";
import { TextArea as AriaTextArea, Label, Text, TextField } from "react-aria-components";

type TextAreaInputProps = {
	label?: string;
	name: string;
	description?: string;
	errorMessage?: string;
	className?: string;
	inputClassName?: string;
	rows?: number;
};

export const TextAreaInput = ({
	label,
	name,
	description,
	errorMessage,
	className,
	inputClassName,
	rows = 3,
	...props
}: TextAreaInputProps) => {
	return (
		<TextField className={cn("flex flex-col py-3 my-3 gap-2", className)}>
			{label && (
				<Label htmlFor={name} className="text-title-medium">
					{label}
				</Label>
			)}

			<AriaTextArea
				id={name}
				rows={rows}
				{...props}
				className={cn(
					"border border-gray-300 px-3 py-3 rounded-lg text-body resize-none focus:outline-none focus:border-primary-600 focus:shadow-none",
					errorMessage ? "border-primary-500" : "border-gray-300",
					inputClassName,
				)}
			/>

			{description && (
				<Text slot="description" className="text-body-small">
					{description}
				</Text>
			)}

			<Text slot="errorMessage" className="text-body-small-medium text-destructive h-1">
				{errorMessage || ""}
			</Text>
		</TextField>
	);
};
